import {apiMethod, APIService} from 'services/APIService';

export type ActivityType = 'contact' | 'viber' | 'telegram' | 'favorite' | 'share' | 'proposal';
export type ActivityFilter = ActivityType | 'all';
export interface ActivityEvent {
  id: number;
  type: ActivityType;
  occurredAt: string;
  datePrecision: 'second' | 'day';
  isRead: boolean;
  offer: {id: number; title: string; image: string | null; price: string; url: string | null};
  actor: {id: number | null; name: string; avatar: string | null};
}
export interface ActivityPage {list: ActivityEvent[]; count: number; snapshotId: number; initialReadRequired: boolean;}
export type ActivitySummary = Record<ActivityType, number>;
export class ActivityFeedAPI extends APIService {
  list = apiMethod<ActivityPage>((type: ActivityFilter, currentPage: number = 0, snapshotId?: number, perPage: number = 25) =>
    this.fetcher.get('/api/activity-feed/list/', {params: {type, currentPage, perPage, snapshotId}}));
  summary = apiMethod<ActivitySummary>(() => this.fetcher.get('/api/activity-feed/summary/'));
  unread = apiMethod<{count: number}>(() => this.fetcher.get('/api/activity-feed/unread-count/'));
  read = apiMethod<{count: number}>((ids: number[]) => this.fetcher.post('/api/activity-feed/read/', {ids}));
  open = apiMethod<{count: number; readThroughId: number | null}>((snapshotId: number) =>
    this.fetcher.post('/api/activity-feed/open/', {snapshotId}));
}
export const activityFeedAPI = new ActivityFeedAPI();
